<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" :id="id">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="fas fa-sort"></i>
                        小説の順番変更
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" v-if="books && books.length > 0">
                    <div class="small mb-3">
                        <span v-if="selected === null">
                            小説を選んでください。
                        </span>
                        <span v-else-if="selected !== null">
                            移動先を選んでください。
                        </span>
                        <span class="text-danger" v-if="isSorted">
                            変更を確定するために保存してください。
                        </span>
                    </div>
                    <div class="list-group">
                        <button
                            class="list-group-item list-group-item-action"
                            :class="{
                                selected: v.id === selected,
                                'font-weight-bold': v.id === sorted,
                            }"
                            @click="select(v.id)"
                            v-for="(v, i) in books"
                            :key="v.id">
                            <i class="fas fa-sort" v-if="selected === null"></i>
                            <i class="fas fa-check" v-else-if="selected === v.id"></i>
                            <i class="fas fa-sort-up" v-else-if="selectedIndex > i"></i>
                            <i class="fas fa-sort-down" v-else-if="selectedIndex < i"></i>
                            {{v.order_number}}.
                            {{v.title}}
                            <span v-if="selected === v.id" class="text-muted small">
                                移動をキャンセル
                            </span>
                            <span v-else-if="selectedIndex > i" class="text-muted small">
                                の前に移動
                            </span>
                            <span v-else-if="selected" class="text-muted small">
                                の後に移動
                            </span>
                        </button>
                    </div>
                </div>
                <div class="modal-body" v-else>
                    <div class="p-5 text-center">
                        小説はありません。
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                    <button type="button" class="btn btn-outline-primary" :disabled="!isSorted" @click="save()">保存</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.selected {
    background-color: #3490dc !important;
    color: white;
    &:hover {
        background-color: #3490dc !important;
        color: white;
    }
}
</style>

<script>
export default {
    props: {
        id: {
            default: "sort-books"
        }
    },
    data() {
        return {
            books: [],
            selected: null,
            sorted: null,
        }
    },
    methods: {
        load() {
            axios.get("/mypage/books/full").then(res => {
                this.books = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        select(id) {
            if (this.selected === null) {
                // 選択
                this.selected = id;
                this.sorted = id;
            } else if (this.selected == id) {
                // 選択解除
                this.selected = null;
                this.sorted = null;
            } else {
                // 順番変更
                const from = this.selectedIndex;
                const dest = _.findIndex(this.books, {id: id});     // fromを抜く前のindex
                const src = this.books.splice(from, 1);
                const to = _.findIndex(this.books, {id: id});       // fromを抜いた後のindex
                if (from < dest) {
                    // 下がる
                    this.books.splice(to + 1, 0, src[0]);
                } else {
                    // 上がる
                    this.books.splice(to, 0, src[0]);
                }
                this.sorted = this.selected;
                this.selected = null;
            }
        },
        save() {
            axios.post("/mypage/books/sort", {books: this.books}).then(res => {
                alert.msg(res.data);
                this.$emit("load");
                $("#" + this.id).modal("hide");
            }).catch(err => { alert.err(err.response) });
        },
    },
    computed: {
        isSorted() {
            for (let i = 0; i < this.books.length; i++) {
                const index = i + 1;
                if (this.books[i].order_number != index) {
                    return true;
                }
            }
            return false;
        },
        selectedIndex() {
            return _.findIndex(this.books, {id: this.selected});
        },
    },
    mounted() {
        $("#" + this.id).on("show.bs.modal", (e) => {
            this.load();
        });
    }
}
</script>